export default {
  arrivalAirport: 'arrivalAirport',
  departureAirport: 'departureAirport',
  sta: 'sta',
  staUtc: 'staUtc',
  std: 'std',
  stdUtc: 'stdUtc',
}
